<template>
  <div class="dashboard__view">
    <div class="page">

      <div class="page__title"></div>
      <div class="page__title__action">
        <button class="btn btn--primary" @click="toggleModal">
          Add New Bank
        </button>

      </div>
    </div>

    <div class="list">
      <div class="tab">
        <div
          class="tab__item"
        >
          Processed
        </div>
      </div>

      <div class="tab__content">

        <div v-if="getPriorityList && (getPriorityList.loading || (getPriorityList.data && getPriorityList.data.length))">
          <!-- Loader -->
          <div class="loader" v-if="getPriorityList.loading">
            <span aria-hidden="true" class="spinner-border"></span>
          </div>
          <table class="table card-table vgt-table" v-else>
            <thead>
              <tr>
                <th>STATE</th>
                <th>BANK NAME</th>
                <th>PRIORITY ORDER</th>
                <th>STATUS</th>
                <th>CREATED ON</th>
                <th style="text-align: left">ACTION</th>
              </tr>
            </thead>
            <tbody>

              <router-link
                :key="item.id"
                :to="{
                  name: 'transfers-details',
                  params: { id: item.id },
                }"
                tag="tr"
                v-for="item in getPriorityList.data"
              >
                <td style="display: flex; align-items: center; text-transform: uppercase">
                  <status-indicator :type="item.is_active ? 'ACTIVE' : 'INACTIVE'" />
                  <status-indicator-with-words :type="item.is_active ? 'ACTIVE' : 'INACTIVE'" />
                </td>

                <td style="text-align: left">
                  {{ getName(item.bank_code) }}
                </td>

                <td style="text-align: left">
                  {{ item.priority_order }}
                </td>

                <td style="display: flex; align-items: center; text-transform: uppercase">
                  <status-indicator :type="item.status" />
                  <status-indicator-with-words :type="item.status" />
                </td>
                <td>
                  {{ moment(item.createdAt).format("llll") }}
                </td>

                <td>
                  <button
                      @click.prevent="toggleModal(item)"
                      class="btn btn--sm btn--danger"
                  >
                    <span>UPDATE</span>
                  </button>
                </td>
              </router-link>
            </tbody>
          </table>

        </div>

        <EmptyState
            v-else
            type="pendingApprovals"
        />
      </div>

    </div>

    <!--  initiate transfer modal-->
    <extend-modal
      classes="justify-content-center"
      :toggle="()=>toggleModal(null)"
      v-if="state.showModal"
      :loading="state.loading"
    >
      <div class="modal-body  p-4 pr-5">

        <svg
            width="60"
            height="60"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
          <path
              d="M13.4406 5.03101C13.57 5.03101 13.6749 4.91998 13.6749 4.78296C13.6749 4.64594 13.57 4.53491 13.4406 4.53491H10.7092C10.5797 4.53491 10.4748 4.64594 10.4748 4.78296C10.4748 4.91998 10.5797 5.03101 10.7092 5.03101H13.4406Z"
              fill="#e00b5b"
          />
          <path
              d="M9.53729 5.99353C9.53729 6.13055 9.64223 6.24158 9.77167 6.24158H13.4406C13.57 6.24158 13.6749 6.13055 13.6749 5.99353C13.6749 5.85651 13.57 5.74548 13.4406 5.74548H9.77167C9.64223 5.74548 9.53729 5.85651 9.53729 5.99353Z"
              fill="#e00b5b"
          />
          <path
              d="M9.77167 7.45191H13.4406C13.57 7.45191 13.6749 7.34088 13.6749 7.20386C13.6749 7.06684 13.57 6.95581 13.4406 6.95581H9.77167C9.64223 6.95581 9.53729 7.06684 9.53729 7.20386C9.53729 7.34088 9.64223 7.45191 9.77167 7.45191Z"
              fill="#e00b5b"
          />
          <path
              d="M6.19479 12.2538C5.97082 12.2538 5.78864 12.4466 5.78864 12.6836V15.0537C5.78864 15.2907 5.97082 15.4835 6.19479 15.4835H7.65585C7.87979 15.4835 8.06198 15.2907 8.06198 15.0537V12.6836C8.06198 12.4466 7.87979 12.2538 7.65585 12.2538H6.19479ZM7.59326 14.9874H6.25742V12.7499H7.59326V14.9874Z"
              fill="#e00b5b"
          />
          <path
              d="M8.86328 12.0221V15.0536C8.86328 15.2906 9.04547 15.4835 9.26941 15.4835H10.7305C10.9544 15.4835 11.1366 15.2906 11.1366 15.0536V12.0221C11.1366 11.7851 10.9544 11.5923 10.7305 11.5923H9.26941C9.0455 11.5923 8.86328 11.7851 8.86328 12.0221ZM9.33203 12.0884H10.6679V14.9874H9.33203V12.0884Z"
              fill="#e00b5b"
          />
          <path
              d="M17.4775 11.6841C17.492 11.6283 17.5004 11.5697 17.5004 11.5091V11.0362C17.5004 10.7307 17.3034 10.4737 17.037 10.398C17.0538 10.3382 17.0632 10.275 17.0632 10.2095V9.73656C17.0632 9.67104 17.0538 9.60783 17.037 9.54804C17.3034 9.47237 17.5004 9.21529 17.5004 8.90979V8.43694C17.5004 8.07224 17.22 7.77551 16.8754 7.77551H15.4314V3.51541C15.4314 3.23121 15.2129 3 14.9444 3H8.42741C8.29797 3 8.19303 3.11103 8.19303 3.24805C8.19303 3.38507 8.29797 3.4961 8.42741 3.4961H14.9444C14.9544 3.4961 14.9627 3.50476 14.9627 3.51541V16.4846C14.9627 16.4952 14.9544 16.5039 14.9444 16.5039H5.05562C5.04556 16.5039 5.03737 16.4952 5.03737 16.4846C5.03737 15.0722 5.03737 4.98377 5.03737 3.51541C5.03737 3.50476 5.04556 3.4961 5.05562 3.4961H7.49031C7.61975 3.4961 7.72469 3.38507 7.72469 3.24805C7.72469 3.11103 7.61975 3 7.49031 3H5.05562C4.78709 3 4.56862 3.23121 4.56862 3.51541V9.07516H3.12459C2.78 9.07516 2.49962 9.37189 2.49962 9.73659V10.2095C2.49962 10.2702 2.50803 10.3287 2.52253 10.3845C2.22659 10.4364 2 10.7085 2 11.0362V11.5091C2 11.8368 2.22659 12.1089 2.52253 12.1609C2.508 12.2167 2.49962 12.2752 2.49962 12.3359V12.8088C2.49962 12.8694 2.50803 12.9279 2.52253 12.9838C2.22659 13.0357 2 13.3077 2 13.6355V14.1084C2 14.2647 2.05181 14.4084 2.13784 14.5218C2.05181 14.6351 2 14.7787 2 14.9351V15.408C2 15.7727 2.28034 16.0695 2.62497 16.0695H2.99963C3.12906 16.0695 3.234 15.9584 3.234 15.8214C3.234 15.6844 3.12906 15.5734 2.99963 15.5734H2.62497C2.53884 15.5734 2.46875 15.4992 2.46875 15.408V14.9351C2.46875 14.8439 2.53881 14.7698 2.62497 14.7698H4.56862V15.5734H3.93675C3.80731 15.5734 3.70238 15.6844 3.70238 15.8214C3.70238 15.9584 3.80731 16.0695 3.93675 16.0695H4.56862V16.4846C4.56862 16.7688 4.78709 17 5.05562 17H14.9444C15.2129 17 15.4314 16.7688 15.4314 16.4846V16.0695H16.8754C17.22 16.0695 17.5004 15.7727 17.5004 15.408V14.9351C17.5004 14.7787 17.4486 14.6351 17.3625 14.5217C17.4486 14.4084 17.5004 14.2647 17.5004 14.1083V13.6354C17.5004 13.5748 17.492 13.5163 17.4775 13.4604C17.7734 13.4084 18 13.1364 18 12.8087V12.3358C18 12.0082 17.7734 11.7361 17.4775 11.6841ZM2.96838 12.8087V12.3358C2.96838 12.2447 3.03847 12.1705 3.12459 12.1705H4.56859V12.9741H3.12459C3.03844 12.9741 2.96838 12.8999 2.96838 12.8087ZM2.96838 9.73656C2.96838 9.64537 3.03847 9.57122 3.12459 9.57122H4.56859V10.3748H3.12459C3.03847 10.3748 2.96838 10.3006 2.96838 10.2095V9.73656ZM2.46875 11.5091V11.0362C2.46875 10.945 2.53881 10.8709 2.62497 10.8709H3.12459H4.56859V11.6744C4.10041 11.6744 3.08759 11.6744 2.62494 11.6744C2.53881 11.6744 2.46875 11.6003 2.46875 11.5091ZM2.62497 14.2737C2.53884 14.2737 2.46875 14.1995 2.46875 14.1084V13.6355C2.46875 13.5443 2.53881 13.4702 2.62497 13.4702H4.56862V14.2737H2.62497ZM17.0316 13.6355V14.1084C17.0316 14.1995 16.9616 14.2737 16.8754 14.2737H15.4314V13.4702H16.8754C16.9616 13.4702 17.0316 13.5443 17.0316 13.6355ZM16.5945 9.73656V10.2095C16.5945 10.3006 16.5244 10.3748 16.4382 10.3748H15.4314V9.57126H16.4382C16.5244 9.57126 16.5945 9.64544 16.5945 9.73656ZM15.4314 10.8709H16.8754C16.9616 10.8709 17.0316 10.945 17.0316 11.0362V11.5091C17.0316 11.6003 16.9616 11.6744 16.8754 11.6744H15.4314V10.8709ZM16.8754 8.27158C16.9616 8.27158 17.0316 8.34573 17.0316 8.43691V8.90979C17.0316 9.00097 16.9616 9.07516 16.8754 9.07516C16.6331 9.07516 15.8029 9.07516 15.4314 9.07516V8.27158H16.8754ZM17.0316 15.408C17.0316 15.4992 16.9616 15.5734 16.8754 15.5734H15.4314V14.7698H16.8754C16.9616 14.7698 17.0316 14.8439 17.0316 14.9351V15.408ZM17.5312 12.8087C17.5312 12.8999 17.4612 12.9741 17.375 12.9741C16.9143 12.9741 15.9005 12.9741 15.4314 12.9741V12.1705H17.375C17.4612 12.1705 17.5312 12.2447 17.5312 12.3358V12.8087Z"
              fill="#e00b5b"
          />
          <path
              d="M13.977 13.29C14.1065 13.29 14.2114 13.1789 14.2114 13.0419V10.6991C14.2114 10.4621 14.0292 10.2693 13.8053 10.2693H12.3442C12.1202 10.2693 11.938 10.4621 11.938 10.6991V15.0536C11.938 15.2906 12.1202 15.4834 12.3442 15.4834H13.8053C14.0292 15.4834 14.2114 15.2906 14.2114 15.0536V14.0337C14.2114 13.8967 14.1065 13.7856 13.977 13.7856C13.8475 13.7856 13.7426 13.8967 13.7426 14.0337V14.9873H12.4068V10.7654H13.7426V13.0419C13.7426 13.1789 13.8476 13.29 13.977 13.29Z"
              fill="#e00b5b"
          />
        </svg>

        <div class="boxed">
          <form class="text-left" @submit.prevent="submit()">
            <!--request form-->
              <div class="text-center">
                <h2 v-if="!state.form.update">Create new Bank</h2>
                <h2 v-else>Update Bank Info</h2>
                <p class="p-2 px-4">Fill in the relevant details below and submit</p>
              </div>
            <div class="form__flex">
              <div class="form__flex__item" style="width: 100%;">
                <label class="form__label text-danger" v-if="!state.form.update" for>Select Bank</label>
                <select class="form__input" v-model="state.form.bank_code" :disabled="state.form.update">
                  <option selected disabled>Select Bank</option>
                  <option v-for="bank of bankList" :value="bank.code" :selected="state.form.bank_code == bank.code">{{bank.bank}}</option>
                </select>
              </div>
            </div>

            <label class="form__label text-danger" style="padding: 10px 15px" for>Status</label>
              <div class="form__flex">
                <div class="form__flex__item" style="width: 100%;">
                  <MultiToggleSwitch :selected="state.form.status" :list="state.status"  :on-change="(status)=> state.form.status=status.field" />
                </div>
              </div>

              <div class="form__flex">
                <div class="form__flex__item" style="width: 100%;">
                  <label class="form__label text-danger" for>priority Order(0-100)</label>
                  <input
                    class="form__input"
                    type="number"
                    v-model.trim="state.form.priority_order"
                  />
                  <span
                    class="attention"
                    v-if="!state.form.priority_order"
                    >Field can't be empty</span
                  >
                </div>
              </div>

            <!--submit-->
            <div class="form__flex">
              <div class="form__flex__item">
                <button class="btn btn--primary"  style="width: 100%;" @click="submit" :disabled="state.loading">
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </extend-modal>
  </div>
</template>

<script>
import emptyTransactions from "../../../components/emptytransactions";
import EmptyState from "@/components/empty-state.vue";
import AccountCard from "../../../components/accountcard";
import Pagination from "../../../components/pagination";
import ExtendModal from "../../../components/ExtendModal";
import StatusIndicator from "../../../components/status-indicator";
import moment  from "moment";
import {
  reactive,
  computed, onBeforeMount,
} from "@vue/composition-api";

import StatusIndicatorWithWords from "../../../components/statusIndicatorWithWords";
import Dropdown from "../../../components/dropdown";
import Textarea from "../../../components/textarea";
import SelectSearch from "../../../components/selectsearch.vue";
import Select from "../../../components/select";
import MultiToggleSwitch from "../../../components/multi-toggle";
import Button from "../../../components/button";

export default {
  name: "PriorityConfig",
  metaInfo: {
    title: "Priority Configuration",
  },

  components: {
    Button,
    MultiToggleSwitch,
    Select,
    Textarea,
    Dropdown,
    StatusIndicatorWithWords,
    StatusIndicator,
    ExtendModal,
    Pagination,
    AccountCard,
    emptyTransactions,
    EmptyState,
    SelectSearch,
  },

  setup(props, { root }) {
    const store = root.$store;
    const state = reactive({
      showModal: false,
      form: {
        bank_code:{},
        priority_order: 4,
        status: ""
      },
      status: [
        { label: 'UP', field: 'up'},
        { label: 'DOWN', field: 'down'},
        { label: 'UNSETTLED', field: 'unsettled'},
      ],
      loading: false
    })

    onBeforeMount(() => {
      store.dispatch("fetchPriorityConfigurationList");
    });

    const bankList = computed(() => store.getters.getBankList);
    const getPriorityList = computed(() => store.getters.getPriorityConfigurationList);

    const handleBankSelected = (output) => {
      state.form.selectedBank = output
    };

    const getName = (bank_code) => {
      const bank = bankList.value.find(
          ({ code, cbn_code }) => code == bank_code || cbn_code === bank_code
      );
      return bank ? bank.name || bank.bank : "";
    }
    const toggleModal = (item=null) => {
      state.showModal = !state.showModal;
      state.form = {
        bank_code:{},
        priority_order: 4,
        status: ""
      };
      if(item && item.status) {
        state.form = {
          ...item,
          update: true,
        }
      }
      state.loading = false
    };
    const checkedBox = reactive({
      selected: "",
      listBoxes: [{ label: 'UP', field: 'up'}, { label: 'DOWN', field: 'down'}, { label: 'UNSETTLED', field: 'unsettled'}]
    })

    const submit = async () => {
      state.loading = true
       try {
         const success = await store.dispatch("createUpdatePriorityConfigurationList", state.form)
         root.$notify({
           group: "notifications-default",
           type: "success text-white",
           title: "Success",
           text: success.data.message
         })
         toggleModal(null)
       } catch (err) {
        let message = 'Error processing request'
        if (err.status !== 404) {
          message = err.data.message || err.message || message
        }
         root.$notify({
          group: "notifications-default",
          type: "error text-white",
          title: "Error",
          text: message
        })
         state.loading = false;
       }

    }
    return {
      state,
      modalType: "loki",
      bankList,
      handleBankSelected,
      toggleModal,
      checkedBox,
      getPriorityList,
      getName,
      moment,
      submit
    };
  },
};
</script>

<style lang="scss" scoped>
.nuban {
  padding: 100px 25px 120px;
  text-align: center;
  &__number {
    color: #e8368f;
    font-size: 32px;
    line-height: 35px;
    padding: 19px 28px 15px;
    background-color: rgba(#e8368f, 0.15);
    border-radius: 16px;
    max-width: 300px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 32px;
    position: relative;
  }

  &__title {
    color: #261940;
    font-size: 18px;
    line-height: 20px;
    margin-bottom: 16px;
  }

  &__caption {
    color: rgba(#261940, 0.8);
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 32px;
  }

  &__copy {
    position: absolute;
    color: #e00b5b;
    font-size: 12px;
    line-height: 13px;
    top: -20px;
    right: 0;
    cursor: pointer;
  }
}
.-mt-3{
  margin-top: -31px;
}
</style>
